// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._19bvidpf{padding-left:0}
._19pk1b66{margin-top:var(--ds-space-050,4px)}
._2mzuglyw{list-style-type:none}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/task-decision/dist/esm/components/TaskList.compiled.css"],"names":[],"mappings":"AAAA,WAAW,cAAc;AACzB,WAAW,kCAAkC;AAC7C,WAAW,oBAAoB","sourcesContent":["._19bvidpf{padding-left:0}\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._2mzuglyw{list-style-type:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
